import { useEffect, useState } from "react"
import api from "../../utils/api"

const EMPTY = { asBiller: [], asCustomer: [] }

// Bill objections for the dashboard bell: customers' objections the person's
// companies must answer, and answers to the person's own objections.
export function useBillObjectionNotices(enabled = true) {
  const [notices, setNotices] = useState(EMPTY)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setNotices(EMPTY)
      return undefined
    }
    let active = true
    setLoading(true)
    api
      .get("/ut-bills/objections/notices")
      .then((response) => {
        if (!active) return
        setNotices({
          asBiller: Array.isArray(response?.data?.asBiller) ? response.data.asBiller : [],
          asCustomer: Array.isArray(response?.data?.asCustomer) ? response.data.asCustomer : [],
        })
      })
      .catch(() => {
        // A missing notification must never break the dashboard.
        if (active) setNotices(EMPTY)
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [enabled])

  return { ...notices, loading }
}
